module.exports = __webpack_public_path__ + "b8400a1c1535f70bf99e9be057e7552e.otf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Regular.otf
// module id = 7
// module chunks = 0